import { render } from "./TheManagerVehicles.vue?vue&type=template&id=65d2dc17"
import script from "./TheManagerVehicles.vue?vue&type=script&lang=js"
export * from "./TheManagerVehicles.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__